import type {
  RouteViewModel,
  RouteViewModelCarrierFinance,
  RouteViewModelFinance,
} from '../types/routeViewModel';

export type RouteCarrierSettlement = {
  carrierName: string;
  rateAmount: number | null;
  totalPaid: number | null;
  remaining: number | null;
  paymentStatus: string;
};

/** Статус оплаты перевозчику — как в FinanceBlock (payable slice). */
export function carrierPayableUiStatus(payable: RouteViewModelFinance['payable'] | null | undefined): string {
  if (!payable) return '—';
  const required = Number(payable.totalRequired);
  if (!Number.isFinite(required) || required <= 0) return '—';
  const paid = Number(payable.totalPaid) || 0;
  const remaining = Number(payable.remaining);
  const eps = 0.01;
  if (Number.isFinite(remaining) && remaining <= eps) return 'Оплачено';
  if (paid <= eps) return 'Не оплачено';
  return 'Частично оплачено';
}

function partyName(entity: unknown): string | null {
  if (!entity || typeof entity !== 'object') return null;
  const raw = (entity as Record<string, unknown>).name;
  return typeof raw === 'string' && raw.trim() ? raw.trim() : null;
}

/** Шапка расчётов с перевозчиком: перевозчик, ставка, агрегат payable. Детали — в obligations EXPENSE. */
export function projectRouteCarrierSettlement(routeView: RouteViewModel): RouteCarrierSettlement {
  const carrierFinance: RouteViewModelCarrierFinance | null | undefined = routeView.carrierFinance;
  const finance = routeView.finance;
  const payable = finance?.payable ?? null;

  const rateAmount =
    carrierFinance?.rateAmount != null
      ? Number(carrierFinance.rateAmount)
      : finance?.routeTotalAmount != null
        ? Number(finance.routeTotalAmount)
        : payable?.totalRequired != null
          ? Number(payable.totalRequired)
          : null;

  return {
    carrierName: partyName(routeView.parties?.carrier) ?? 'Не назначен',
    rateAmount: Number.isFinite(rateAmount ?? NaN) ? rateAmount : null,
    totalPaid: payable?.totalPaid != null ? Number(payable.totalPaid) : null,
    remaining: payable?.remaining != null ? Number(payable.remaining) : null,
    paymentStatus: carrierPayableUiStatus(payable),
  };
}
